import { gql } from 'apollo-boost';

export default gql`
    mutation AcceptTermsAndConditions($input: AcceptTermsAndConditions) {
        termsAndConditions(input: $input) {
            hasUsageAgreement
        }
    }
`;
